import React, { Component } from 'react';

class Code extends Component {
    render() {
        return (
            <pre className="p-3 bg-light border rounded">{this.props.children}</pre>
        );
    }
}

export default Code;



// WEBPACK FOOTER //
// ./src/reference/ui/Code.js